import React, { useEffect, useState } from "react";
import "../../assets/styles/styles.scss";
import Metadata from "../../components/Metadata";
import Header from "../../components/dashboard/Header";
import Menu from "../../components/dashboard/Menu";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
import { Spin, Input, List, Tag, Pagination, Select } from "antd";
import { useNavigate } from "react-router-dom";

const { Search } = Input;
const { Option } = Select;

export const orderSteps = [
  { value: "ordered", label: "Commandé", color: "#FF4747" },
  { value: "preparing", label: "En préparation", color: "orange" },
  { value: "ready-for-delivery", label: "Prête pour la livraison", color: "purple" },
  { value: "delivering", label: "En cours de livraison", color: "cyan" },
  { value: "delivered", label: "Livré", color: "green" },
];

export default function PublicAppOrders() {
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchOrders() {
      setLoading(true);

      const ordersSnap = await getDocs(collection(db, "medicationOrders"));
      const ordersData = await Promise.all(
        ordersSnap.docs.map(async (docSnap) => {
          const data = docSnap.data();

          let patient = { firstName: "_", lastName: "_" };
          if (data.patientId) {
            const patientDoc = await getDoc(doc(db, "medicationUsers", data.patientId));
            if (patientDoc.exists()) patient = patientDoc.data();
          }

          let driver = { firstName: "_", lastName: "_" };
          if (data.driverId) {
            const driverDoc = await getDoc(doc(db, "medicationUsers", data.driverId));
            if (driverDoc.exists()) driver = driverDoc.data();
          }

          return {
            id: docSnap.id,
            ...data,
            patient,
            driver,
          };
        })
      );

      setOrders(ordersData);
      setLoading(false);
    }

    fetchOrders();
  }, []);

  const handleSearchChange = (e) => setSearch(e.target.value);
  const handleStatusChange = (value) => setStatusFilter(value);

  const filteredOrders = orders
    .filter((o) => o.number?.toLowerCase().includes(search.toLowerCase()))
    .filter((o) => (statusFilter ? o.status === statusFilter : true));

  const paginatedOrders = filteredOrders.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const handleOrderClick = (id) => navigate(`/admin/public-app-orders/${id}`);

  const getStatusTag = (status) => {
    const step = orderSteps.find((s) => s.value === status);
    return step ? (
      <Tag color={step.color} style={{ fontWeight: "bold" }}>
        {step.label}
      </Tag>
    ) : (
      <Tag>{status}</Tag>
    );
  };

  const statusCounts = orderSteps.map((step) => ({
    ...step,
    count: orders.filter((o) => o.status === step.value).length,
  }));

  if (loading) return <Spin tip="Chargement..." />;

  return (
    <>
      <h2 className="dashboard-title" style={{ marginBottom: 20 }}>
        Liste des commandes
      </h2>

      <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
        <Search
          placeholder="Rechercher par numéro de commande..."
          onChange={handleSearchChange}
          value={search}
          allowClear
          style={{ width: 300 }}
        />
        <Select
          placeholder="Filtrer par statut"
          onChange={handleStatusChange}
          value={statusFilter || undefined}
          style={{ width: 250 }}
          allowClear
        >
          {statusCounts.map((step) => (
            <Option key={step.value} value={step.value}>
              {step.label} ({step.count})
            </Option>
          ))}
        </Select>
      </div>

      <List
        bordered
        dataSource={paginatedOrders}
        renderItem={(order) => (
          <List.Item
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "15px 20px",
              borderRadius: 8,
              marginBottom: 10,
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              backgroundColor: "#fff",
              transition: "transform 0.1s",
            }}
            onClick={() => handleOrderClick(order.id)}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            <div>
              <strong>Commande #:</strong> {order.number} <br />
              <strong>Client:</strong> {order.patient.firstName} {order.patient.lastName} <br />
              <strong>Livrée par:</strong> {order.driver.firstName} {order.driver.lastName} <br />
              <strong>Date:</strong>{" "}
              {order.createdAt?.toDate
                ? order.createdAt.toDate().toLocaleString()
                : "—"}
            </div>
            {getStatusTag(order.status)}
          </List.Item>
        )}
      />

      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={filteredOrders.length}
        onChange={(page) => setCurrentPage(page)}
        style={{ marginTop: 20, textAlign: "center" }}
        itemRender={(page, type, originalElement) => {
          if (type === "item") {
            return React.cloneElement(originalElement, {
              style: {
                borderColor: "#FF4747",
                color: page === currentPage ? "#fff" : "#FF4747",
                backgroundColor: page === currentPage ? "#FF4747" : "#fff",
                borderRadius: 4,
              },
            });
          }
          return originalElement;
        }}
      />
    </>
  );
}
